import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
// CSS for flatpickr is served separately via Propshaft (see
// vendor/assets/stylesheets/flatpickr.css and the stylesheet_link_tag
// in the layout). Don't import it here — esbuild's CSS-from-JS handling
// is unreliable with our build setup, and Tailwind v4's --minify would
// purge JS-injected selectors anyway.

export default class extends Controller {
  static values = {
    enableTime: { type: Boolean, default: false },
    dateFormat: { type: String, default: "Y-m-d" },
    altFormat:  { type: String, default: "M j, Y" },
    minDate:    String,
    maxDate:    String
  }

  connect() {
    const config = {
      altInput: true,
      altFormat: this.altFormatValue,
      dateFormat: this.dateFormatValue,
      enableTime: this.enableTimeValue
    }

    if (this.hasMinDateValue) config.minDate = this.minDateValue
    if (this.hasMaxDateValue) config.maxDate = this.maxDateValue

    this.instance = flatpickr(this.element, config)
  }

  disconnect() {
    this.instance?.destroy()
  }
}
